<template>
  <div class="page_bs_">
    <header>
      <div class="left_">
        <img class="img_" :src="info.productPicuter" />
        <div class="company_">{{ info.productDigest }}</div>
      </div>
      <div class="right_">
        <div>
          <h1>
            {{ info.productName }}
            <i class="i_icon_ i_new_" v-if="info.hasNew == '1'"></i>
            <i class="i_icon_ i_hot_" v-if="info.hasHot == '1'"></i>
          </h1>
          <p class="desc_" v-if="riskLiability == '0'">
            <template v-for="(item, index) in info.riskLiabilityVoList">
              <p :key="index" v-if="index < 3">
                {{ item.riskLiability }}：{{ item.sumAssured }}
              </p>
            </template>
          </p>
          <p class="desc_" v-else>
            <div class="pre_line">{{info.productSourceNew || info.prooductSellPoint}}</div>
          </p>
        </div>
        <p class="link_" @click="goDetail(info)">
          立即投保
        </p>
      </div>
    </header>
    <section class="content_">
      <h3>产品资料</h3>
      <ul class="list_">
        <li
          :class="{ light_: item.light }"
          :key="index"
          v-for="(item, index) in list"
          
        >
        <!-- @click="handleChange(item)" -->
          <div @click="showFile(item)">
            <img
              :src="item.imgUrl"
              class="icon_"
            />
            <div>{{ item.name }}</div>
          </div>
        </li>
      </ul>
    </section>
    <p>更多推广功能正在赶来的路上，敬请期待～</p>
  </div>
</template>
<style lang="scss" scoped>
.page_bs_ {
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 12px;
  .desc_ {
    p {
      color: rgba(153, 153, 153, 1);
    }
  }

  header {
    padding: 16px 20px;
    border-bottom: 8px solid #f5f5f5;
    text-align: left;
    display: flex;
    .left_ {
      display: inline-block;
      width: 30%;
      .company_ {
        background: #f5f5f5;
        border-radius: 0px 0px 7px 7px;
        line-height: 23px;
        margin-top: -4px;
        text-align: center;
      }
      .img_ {
        width: 100%;
        height: 100px;
        background: #eee;
        border-radius: 0.186667rem 0.186667rem 0 0;
      }
    }
    .right_ {
      // float: right;
      text-align: left;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      // height: 124px;
      width: 63%;
      padding-bottom: 3px;
      margin-left: 10px;
      h1 {
        font-size: 15px;
        color: #333;
        line-height: 21px;
        font-weight: bold;
      }
      .desc_ {
        font-size: 11px;
        color: #999999;
        line-height: 20px;
      }
      .pre_line {
        font-size: 11px;
        color: #999999;
        line-height: 20px;
        white-space: pre-line;
      }
      .link_ {
        width: 60px;
        height: 27px;
        line-height: 27px;
        text-align: center;
        background: #FF5744;
        border-radius: 7px;
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
      }
    }
  }
  .content_ {
    padding-top: 17px;
    h3 {
      font-size: 0.4rem;
      font-weight: bold;
    }
  }
  .list_ {
    padding: 24px 33px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      font-size: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.45);
      margin-right: 30px;
      margin-bottom: 13px;
      a {
        div {
          color: #999;
        }
      }
      .icon_ {
        width: 38px;
        height: 38px;
        margin-bottom: 8px;
      }
      &.light_ {
        color: #333333;
        a {
          div {
            color: #333;
          }
        }
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
  .i_icon_ {
    display: inline-block;
    width: 0.35rem;
    height: 0.3rem;
  }
  .i_new_ {
    background: url("../../../assets/image/bs-2.0/new.png") no-repeat;
    background-size: 100% auto;
    margin-left: 0.26rem;
  }
  .i_hot_ {
    background: url("../../../assets/image/bs-2.0/hot.png") no-repeat;
    background-size: 100% auto;
    margin-left: 0.13rem;
  }
}
</style>
<script>
import api from "@/utils/api";

function convert(url, joint) {
  if (url.indexOf("?") != -1) {
    joint = "&" + joint;
  } else {
    joint = "?" + joint;
  }
  return joint;
}
function toubao({ productCode, mainId, productUrl, from }) {
  let url;
  if (null != productCode && "" != productCode && "null" != productCode) {
    url =
      "/authority/wxstore/getProductWechatUrl?productCode=" +
      productCode +
      "&mainId=" +
      mainId;
  } else {
    url = productUrl;
  }
  if (from !== undefined) {
    url = url + convert(url, from);
  }
  let origin = window.location.origin
  if (!/^http/.test(url)) {
    url = `${origin}${url}`;
  }
  window.location.href = url;
}
export default {
  data() {
    return {
      actName: "推广海报",
      list: [
        {
          name: "推广海报",
          imgUrl: require("../../../assets/image/bs-2.0/black/1.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/1.png"),
          light: 1,
          pathName: "productShare",
          productType: '0',
          isLight: false
        },
        {
          name: "产品条款",
          imgUrl: require("../../../assets/image/bs-2.0/black/2.png"),
          // imgUrl: require("../../../assets/image/bs-2.0/light/2.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/2.png"),
          pathName: "productCommon",
          productType: '2',
          isLight: false
        },
        {
          name: "投保须知",
          imgUrl: require("../../../assets/image/bs-2.0/black/3.png"),
          // imgUrl: require("../../../assets/image/bs-2.0/light/3.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/3.png"),
          pathName: "productCommon",
          productType: '5',
          isLight: false
        },
        {
          name: "职业类别",
          imgUrl: require("../../../assets/image/bs-2.0/black/4.png"),
          // imgUrl: require("../../../assets/image/bs-2.0/light/4.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/4.png"),
          pathName: "productCommon",
          productType: '6',
          isLight: false
        },
        {
          name: "培训课件",
          imgUrl: require("../../../assets/image/bs-2.0/black/5.png"),
          // imgUrl: require("../../../assets/image/bs-2.0/light/5.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/5.png"),
          pathName: "productCommon",
          productType: '15',
          isLight: false
        },
        {
          name: "直播课堂",
          imgUrl: require("../../../assets/image/bs-2.0/black/6.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/6.png"),
          pathName: "productCommon",
          productType: '12',
          isLight: false
        },
        {
          name: "客户告知书",
          imgUrl: require("../../../assets/image/bs-2.0/light/7.png"),
          // imgUrl: require("../../../assets/image/bs-2.0/light/7.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/7.png"),
          pathName: "productCommon",
          productType: '10',
          isLight: false
        },
        {
          name: "其他服务",
          imgUrl: require("../../../assets/image/bs-2.0/black/8.png"),
          // imgUrl: require("../../../assets/image/bs-2.0/light/8.png"),
          imgUrlA: require("../../../assets/image/bs-2.0/light/8.png"),
          pathName: "productCommon",
          productType: '99',
          isLight: false
        }
      ],
      result: 0,
      info: {},
      isShowPoster: '', //0 不展示  1展示
      isShowHS: '', //0 不展示  1展示,
      riskLiability: '', //0 责任  1卖点,
    };
  },
  mounted() {
    let { isShowPoster,isShowHS,riskLiability } = this.$route.query
    this.isShowPoster = isShowPoster
    this.isShowHS = isShowHS
    this.riskLiability = riskLiability
    this.fetchData();
    this.hideOptionMenu();
    this.queryWxMaterial()
  },
  methods: {
    checkHotAndBannerProduct(){
      let data = {
        defaultUserId: this.$route.query.userid,
        productCode: this.$route.query.code,
      }
      return api.checkHotAndBannerProduct(data).then(res => {
        console.log(res,"----resssss")
        if (res.data && res.data == '1') {
          this.result = res.data
        }
      })
    },
    hideOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("hideOptionMenu");
        }
      );
    },
    toubao({ productCode, mainId, productUrl, from }) {
      let url;
      if (null != productCode && "" != productCode && "null" != productCode) {
        url =
          "/authority/wxstore/getProductWechatUrl?productCode=" +
          productCode +
          "&mainId=" +
          mainId;
      } else {
        url = productUrl;
      }
      if (from !== undefined) {
        url = url + convert(url, from);
      }
      let origin = "http://wx.run4wd.com";
      if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
        origin = "http://wx.yutai365.com";
      }
      if (!/^http/.test(url)) {
        url = `${origin}${url}`;
      }
      window.location.href = url;
    },
    goDetail(info) {
      let data = {
        productCode: this.$route.query.code,
        mainId: this.$route.query.mainId,
        productUrl: info.productUrl,
      }
      this.checkHotAndBannerProduct().then(res =>{
        if(this.result != "1"){
          this.showToast("账号未绑定或产品未配置，无法投保！")
          console.log(2,this.result)
        } else {
          console.log(3,this.result)
          // this.toubao(data)
          // 商城为C端商城，并且默认用户不允许出单时，商城点击产品投保时， wechatUrl 字段为空 提示"请先登录或者注册"
          let url = this.$route.query.wechatUrl
          if (!url || url == 'undefined') {
            this.showToast('请先登录或者注册')
            return false
          }
          this.judgeOnlyPcOrCpsAndGetPosterUrl(this.$route.query.code,url,this.$route.query.mainId)
        }
      })
      
    },
    judgeOnlyPcOrCpsAndGetPosterUrl(productCode,url,mainId) {
      api.judgeOnlyPcOrCpsAndGetPosterUrl(productCode).then(res => {
        let judgeFlag = res.data.content.judgeFlag
        let pcOrCpsPosterUrl = res.data.content.posterUrl || '';
        if(judgeFlag=='1'){
          this.$router.push({
            path: '/bs/PCPolicyGuide',
            query: {
              pcOrCpsPosterUrl: encodeURIComponent(pcOrCpsPosterUrl)
            }
          })
          return;
        }
        window.location.href = url;
      })
    },
    handleChange(item) {
      if (item.name != "直播课堂") {
        this.actName = item.name;
      } else {
        this.showToast("该功能尚未开发，敬请期待！")
      }
    },
    showToast(text) {
      this.$createToast({
        txt: text,
        time: 1000,
        type: "txt"
      }).show();
    },
    fetchData() {
      let data = {
        userId: this.$route.query.userid,
        productCode: this.$route.query.code,
        mainId: this.$route.query.mainId
      };
      api
        .queryProduct(data)
        .then(res => res.data)
        .then(data => {
          this.info = data.content.productDetail;
        });
    },
    // forwardToDetail() {
    //   toubao(this.$route.query);
    // },
    // forwardToShare () {
    //     this.$router.push({
    //         name: 'productShare',
    //         query: {
    //             mainId: this.info.mainId,
    //             productCode: this.info.productCode,
    //             userId: this.$route.query.userId
    //         }
    //     })
    // }
    queryWxMaterial() {
      api.queryWxMaterial({
        productCode: this.$route.query.code,
        userId: this.$route.query.userid,
        mainId: this.$route.query.mainId
      }).then(res => res.data).then(data => {
        this.data = data.content
        // customerNotificationList.push({
        //   materialName: '客户告知书',
        //   materialContent: data.content.customerTemplate,
        //   whetherMandatoryRead: 'http'
        // })
        // this.data['customerNotification'] = customerNotificationList
        // this.getListByType(this.query.type)

        this.list.forEach(item => {
          this.getIconType(item,this.data)
        })
      })
    },
    getIconType(item,data) {
      let name = item.name
      let content = ''
      if (name == '推广海报' && this.isShowPoster == '1') {
        item.imgUrl = item.imgUrlA
          item.isLight = true
      }
      if (name == '产品条款') {
        let content = this.data['productTerms']
        if (content && content.length != 0) {
          item.imgUrl = item.imgUrlA
          item.isLight = true
        }
      } else if (name == '投保须知') {
        let content = this.data['insurances']
        if (content && content.length != 0) {
          item.imgUrl = item.imgUrlA
          item.isLight = true
        }
      } else if (name == '职业类别') {
        let content = this.data['occupationCategories']
        if (content && content.length != 0) {
          item.imgUrl = item.imgUrlA
          item.isLight = true
        }
      } else if (name == '培训课件') {
        let content = this.data['trainingCourseware']
        if (content && content.length != 0) {
          item.imgUrl = item.imgUrlA
          item.isLight = true
        }
      } else if (name == '直播课堂') {
        let content = this.data['liveClass']
        if (content && content.length != 0) {
          item.imgUrl = item.imgUrlA
          item.isLight = true
        }
      } else if (name == '客户告知书') {
        let content = this.data['customerTemplate']
        if (content && content != '') {
          item.imgUrl = item.imgUrlA
          item.isLight = true
        }
      }
      else if (name == '其他服务') {
        let content = this.data['others']
        if (content && content.length != 0) {
          item.imgUrl = item.imgUrlA
          item.isLight = true
        }
      }
    },
    showFile(item) {
      if (!item.isLight) {
        return false
      }
      this.$router.push({
        name: item.pathName,
        query: {
          code: this.$route.query.code,
          userid: this.$route.query.userid,
          mainId: this.$route.query.mainId,
          type: item.productType,
          isShowHS: this.isShowHS,
          isShowPoster: this.isShowPoster,
          riskLiability: this.riskLiability
        }
      })
    }
  }
};
</script>
